module.exports = __webpack_public_path__ + "static/img/craigTwo.f19579ed.png";